// extracted by mini-css-extract-plugin
export var code = "Code-module--code--T01kr";
export var inline = "Code-module--inline--RhXgp";
export var root = "Code-module--root--XVJfV";